import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import TopHero from "@/Components/Universal/TopHero";
import FrontLayout from "@/Layouts/FrontLayout";
import { Head } from "@inertiajs/react";

import PromoImage1 from '@resources/promo-image-1.jpg?format=webp&quality=75&w=1000;767;500&as=srcset&imagetools';
import PromoImage2 from '@resources/promo-image-2.jpg?format=webp&quality=75&w=1000;767;500&as=srcset&imagetools';
import PromoImage3 from '@resources/promo-image-3.jpg?format=webp&quality=75&w=1000;767;500&as=srcset&imagetools';
import PromoImage4 from '@resources/promo-image-4.jpg?format=webp&quality=75&w=1000;767;500&as=srcset&imagetools';
import PromoImage5 from '@resources/promo-image-5.jpg?format=webp&quality=75&w=1000;767;500&as=srcset&imagetools';

const DetailsYslab = ({ apartmentName }: { apartmentName: string }) => {
    return (
        <>
            <Head title="Osiedle Kusocińskiego">
                <meta name="description" content="Osiedle Kusocińskiego" />
            </Head>
            <FrontLayout>
                <TopHero
                    image="apartments-breadcrumbs-bg.webp"
                    text={`Mieszkanie ${apartmentName.replace("_", "/")}`}
                />
                <section className="w-full h-screen mb-24">
                    <iframe
                        src={`https://allinone.prod.resimo.io/monday/kusocinskiego/#/?app=0&lang=pl&apartment=${apartmentName.replace("_", "/")}`}
                        allow="fullscreen"
                        className="allinone-iframe w-full h-full"
                    ></iframe>
                </section>
                <Container>
                    <Row>
                        <Column>
                            {apartmentName == 'A_02' &&
                                <Row className="pt-18 pb-6">
                                    <Column xl={11} lg={11}>
                                        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
                                            <div className="bg-[#F5F8F9] rounded-2xl p-4 flex flex-col">
                                                <img srcSet={PromoImage1} alt="Promo" className="w-full h-[256px] rounded-2xl object-cover lg:mb-8 mb-4" loading='lazy' />
                                                <p className="text-text text-p leading-p tracking-[0.45px]">Mieszkanie jest w pełni wykończone, umeblowane</p>
                                            </div>
                                            <div className="bg-[#F5F8F9] rounded-2xl p-4 flex flex-col">
                                                <img srcSet={PromoImage2} alt="Promo" className="w-full h-[256px] rounded-2xl object-cover lg:mb-8 mb-4" loading='lazy' />
                                                <p className="text-text text-p leading-p tracking-[0.45px]">Zaprojektowane przez Architektów Kodo</p>
                                            </div>
                                            <div className="bg-[#F5F8F9] rounded-2xl p-4 flex flex-col">
                                                <img srcSet={PromoImage3} alt="Promo" className="w-full h-[256px] rounded-2xl object-cover lg:mb-8 mb-4" loading='lazy' />
                                                <p className="text-text text-p leading-p tracking-[0.45px]">Wyposażenie w sprzęt AGD, RTV najwyższej klasy</p>
                                            </div>
                                            <div className="bg-[#F5F8F9] rounded-2xl p-4 flex flex-col">
                                                <img srcSet={PromoImage4} alt="Promo" className="w-full h-[256px] rounded-2xl object-cover lg:mb-8 mb-4" loading='lazy' />
                                                <p className="text-text text-p leading-p tracking-[0.45px]">Zabudowa meblarska na wymiar</p>
                                            </div>
                                            <div className="bg-[#F5F8F9] rounded-2xl p-4 flex flex-col">
                                                <img srcSet={PromoImage5} alt="Promo" className="w-full h-[256px] rounded-2xl object-cover lg:mb-8 mb-4" loading='lazy' />
                                                <p className="text-text text-p leading-p tracking-[0.45px]">Dostępne "od ręki"</p>
                                            </div>
                                        </div>
                                    </Column>
                                </Row>
                            }
                        </Column>
                    </Row>
                </Container>
            </FrontLayout>
        </>
    );
};

export default DetailsYslab;
